import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  formBox: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    width:"800px",
    boxShadow: "5px 10px 18px #888888",
    padding:"30px"
  },
  iconCircle: {
    clipPath: "circle(25px at 50% 50%)",
    background:"#bb0d66",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-50px",
    height: "50px"
  },
  buttons: {
    display: 'flex',
    flexDirection:"row",
    justifyContent: 'center'
  },
  backButton: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#9A9A9A",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  buttonContained: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#BB0D66",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  alert: {
    backgroundColor: theme.palette.warning.dark
  },
}));
